/* VENITI — micro-interactions + lazy + estimator hook */
(function(){
  // Fade viewport reveal
  const io = new IntersectionObserver((els)=>{
    els.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('is-in'); });
  },{rootMargin:"0px 0px -10% 0px", threshold:0.01});
  document.querySelectorAll('.fv').forEach(el=>io.observe(el));

  // Logo gate
  const gate = document.querySelector('.logo-gate');
  if(gate){
    requestAnimationFrame(()=>gate.classList.add('is-show'));
    // Prefer real LCP: close after 1100ms or when user taps
    const close = ()=> gate.classList.add('is-hide');
    setTimeout(close, 1100);
    gate.addEventListener('click', close, {once:true});
  }

  // Simple lazy images
  const lazy = document.querySelectorAll('img[data-src]');
  const io2 = new IntersectionObserver((es)=>{
    es.forEach(e=>{
      if(!e.isIntersecting) return;
      const img = e.target;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      io2.unobserve(img);
    });
  },{rootMargin:"200px"});
  lazy.forEach(i=>io2.observe(i));

  // Estimator hook (optional): emits event with estimate payload
  window.VenitiEstimator = {
    estimateWardrobe({width_mm=2500, doors=5, finish='painted'}={}){
      // Hypersimple model — tune later
      const doorPrice = {painted:380, oak:520, walnut:620}[finish] || 380;
      const sizeFactor = Math.max(1, width_mm/2400);
      const price = Math.round(doorPrice*doors*sizeFactor/10)*10;
      const payload = {price, width_mm, doors, finish};
      document.dispatchEvent(new CustomEvent('veniti:estimate', {detail:payload}));
      return payload;
    }
  };
})();
